import React from "react";

const OrganizationStorage = () => {
    return <>OrganizationStorage...</>;
};

export default OrganizationStorage;
